import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { CreditsLogResponse } from '../interfaces/credits-log';

@Injectable({
  providedIn: 'root',
})
export class CreditsAdapter {
  private readonly http = inject(HttpClient);

  /**
   * Loads a page of credit ledger entries for the current company.
   *
   * @param {number} offset Number of rows to skip.
   * @param {number} limit Page size.
   * @returns {Observable<CreditsLogResponse>} Total count and page of log entries.
   */
  getCreditsLog(offset: number, limit: number): Observable<CreditsLogResponse> {
    const params = new HttpParams()
      .set('offset', offset.toString())
      .set('limit', limit.toString());

    return this.http.get<CreditsLogResponse>(
      `${environment.apiBaseUrl}/company/credits/log`,
      { params },
    );
  }
}
